import { routes } from '@/app/routing/router'
import { UnifiedProfileView } from './view'
const currentRoute = routes.unifiedProfile

const UnifiedProfileRoute = {
  route: currentRoute,
  view: UnifiedProfileView,
}

export { currentRoute, UnifiedProfileRoute }
